import CardImageFlip from "./CardImageFlip";
import partybluetan from "../img/party-blue-tan.jpeg"
import partygreenflower from "../img/party-green-flower.jpeg"
import partytanwhite from "../img/party-tan-white.jpeg"
import slingpartytanwhite from "../img/Sling-party-tan-white.jpeg"
import heroparty from "../img/hero-partybag.jpeg"
import partywhitegreen from "../img/party-white-green.jpeg"
import herohandbag from "../img/hero-handbag.jpeg"
import womenholdingpartybag from "../img/indian-women-holding-partybag.png"

const MasterCardImgFlipParty = () => {
    return (
        <section class="cards-section lemon-green" id="audit">
            <div class="container">
                <h2 class="section-title">Party Bags</h2>
                <div class="cards-grid">
                    <CardImageFlip imgFront={heroparty} imgBack={partywhitegreen} />
                    <CardImageFlip imgFront={partygreenflower} imgBack={partybluetan} />
                    <CardImageFlip imgFront={partytanwhite} imgBack={slingpartytanwhite} />
                    <CardImageFlip imgFront={herohandbag} imgBack={womenholdingpartybag} />
                  
                 </div>
            </div>
        </section>
    );
}

export default MasterCardImgFlipParty;